<template>
	<div class="board">
		<v-row>
			<v-col cols="12">
				<v-row>
					<v-col cols="4" class="align-self-center fast-play-header left-header">
						<img src="./images/logo_board.png" class="logo" />
					</v-col>
					<v-col cols="4" class="fast-play-header">
						<v-row class="pick-numbers">
							<v-col cols="6" class="text-center picks">
								PICKS
							</v-col>
							<v-col cols="6" class="text-center picks">
								NUMBERS
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="4" class="text-center align-self-center card-header fast-play-header right-header">
						PAYOUTS
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-row align="stretch">
					<v-col cols="4" class="d-flex flex-column green-background left-footer">
						<upcoming-sortition id="upcoming-result" :upcoming-sortition="upcomingSortition"
							@refresh="fetchUpcomingSortition"></upcoming-sortition>
						<div class="card-header"><span>Winning Numbers</span></div>
						<result-display v-for="result in results.entries.slice(0, 1)" :key="result.sortition.id" :result="result"
							white>
						</result-display>
						<img src="./images/logo.png" class="bottom-star" />
					</v-col>
					<v-col cols="4" class="d-flex flex-column white-background " v-if="results.entries.slice(1).length > 0">
						<result-display v-for="(result, index) in results.entries.slice(1)" :key="index" :result="result">
						</result-display>
					</v-col>
					<v-col cols="4" class="d-flex order-2 order-md-2 flex-column gray-background right-footer">
						<prizes-card v-if="showPrizes" :prizes="prizes"></prizes-card>
						<results-card class="card-results" v-if="showResults" display-horizontally
							:results-by-lottery="resultsToShow"></results-card>
					</v-col>
				</v-row>
			</v-col>
			<v-col id="page-url" cols="12" class="text-center p-0">
				<span>Visit our page {{ url }}</span>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ResultDisplay from "./ResultDisplay.vue";
import UpcomingSortition from "./UpcomingSortition.vue";
import BaseBoard from "../BaseBoard.js";
import PrizesCard from "./PrizesCard.vue";
import ResultsCard from '../../common/ResultsCard.vue';

export default {
	name: "Board",
	extends: BaseBoard,
	components: {
		ResultsCard,
		UpcomingSortition,
		ResultDisplay,
		PrizesCard
	},
	mounted() {
		this.showNResults = 4;
	}
};
</script>

<style scoped lang="scss">
@import "css/variables";
/*@import "css/main";*/

.bottom-star {
	position: absolute;
	max-height: 150px;
	bottom: 50px;
	left: 100px;
}

.fast-play-header {
	height: 76px;
	background-color: $green;
	color: white;
}

.right-header {
	border-top-right-radius: 20px;
}

.left-header {
	border-top-left-radius: 20px;
}

.right-footer {
	border-bottom-right-radius: 20px;
}

.left-footer {
	border-bottom-left-radius: 20px;
}

.pick-numbers {
	font-size: 1.7rem;
	color: white;
}

.picks {
	padding-top: 0;
}

.logo {
	max-height: 70px;
	margin-right: 20px;
	padding-top: 0;
}

.logo-small {
	max-height: 25px;
	margin-right: 10px;
	margin-bottom: 10px;
}

.result-display {
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}
}

.v-card {
	background-color: $green;
	color: white;
	border-radius: 30px;

	&:not(#primary-card) {
		box-shadow: 8px 6px 20px 0 #07000080;
	}
}

// ::v-deep .v-card #countdown {
//   line-height: 60px;
//   text-align: center;
//   font-family: "RobotoBlack", serif;
// }

// #upcoming-sortition {
//   margin-top: 15px;
//   margin-bottom: 15px;
// }

.card-header {
	color: white;
	font-size: 1.7rem;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
}

.p-0 {
	padding: 0;
}

#page-url span {
	font-size: 2rem;
	color: white;
}

.gray-background {
	background-color: #dedede;
}

.green-background {
	background-color: $green;
}

.white-background {
	background-color: white;
}
</style>
